<template>
  <div
    id="signin"
    v-bind:class="{
      'is-loading': state.isLoading,
      'open-modal': state.openModal
    }"
  >
    <div class="loading__overlay loading__overlay--inverse">
      <div class="loading"></div>
    </div>

    <div v-if="!state.formCompleted && data">
      <h1 v-if="data && data.branding">
        {{ pageName }}
      </h1>

      <input
        placeholder="Enter employee name"
        class="input"
        name="autoComplete"
        id="autoComplete"
        type="search"
        v-model="autoCompleteVisitor"
        v-on:keyup="onAddressTyped"
        autocomplete="off"
      />
      <ul class="letters">
        <li v-for="letter in genCharArray('A', 'Z')" :key="letter">
          <a
            href="#"
            @click.prevent="
              autoCompleteVisitor = letter;
              onAddressTyped();
            "
            >{{ letter }}</a
          >
        </li>
      </ul>

      <ul class="visitor-results">
        <li
          v-for="(item, index) in visitorResults.items"
          :key="index"
          @click="selectVisiting(item)"
        >
          <img :src="item.photoUrl" />
          <div class="visitor-results-details">
            <h4>{{ item.firstName }} {{ item.lastName }}</h4>
            <p v-if="item.email" class="is-hidden-mobile">
              Email: {{ item.email }}
            </p>
            <p v-if="item.mobile" class="is-hidden-mobile">
              Phone: {{ item.mobile }}
            </p>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="black"
            width="28px"
            height="28px"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </li>
      </ul>
      <div class="columns is-vcentered">
        <div class="column is-narrow">
          <button @click.stop="goBack()" class="button">
            Back
          </button>
        </div>
        <div class="column is-narrow" style="margin-left: auto;">
          <button
            v-if="allowSkip"
            @click.stop="skip()"
            class="appButton button-large button-blue button is-primary margin-top margin-bottom"
          >
            <div class="loading"></div>
            Skip
          </button>
        </div>
      </div>

      <div
        class="visitor-selected-hold"
        v-if="visiting"
        @click.self="closeModal()"
      >
        <div class="visitor-selected">
          <div class="visiting-selected-close" @click.stop="closeModal()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="black"
              width="18px"
              height="18px"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              />
            </svg>
          </div>
          <img :src="visiting.photoUrl" />
          <div class="visitor-results-details">
            <p>
              Your are about to visit
            </p>
            <h4>{{ visiting.firstName }} {{ visiting.lastName }}</h4>
            <p v-if="visiting.email">Email: {{ visiting.email }}</p>
            <p v-if="visiting.mobile">Phone: {{ visiting.mobile }}</p>
          </div>

          <button
            @click.stop="confirm()"
            class="appButton button-large button-blue button is-primary margin-top margin-bottom"
          >
            <div class="loading"></div>
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getCheckInDataMixin } from '@/mixins.js';

export default {
  name: 'SignOut',
  mixins: [getCheckInDataMixin],
  components: {},
  data() {
    return {
      state: {
        openModal: false,
        isLoading: false,
        activeStep: 0,
        formCompleted: false,
        formCompletedMsg: 'Sorry theres been an error'
      },
      autoCompleteVisitor: '',
      visiting: null,
      visitorResults: [
        /*{
          name: "Mark Paula",
          img:
            "https://widgetwhats.com/app/uploads/2019/11/free-profile-photo-whatsapp-4-300x300.png"
        },
        {
          name: "Mark8 Sourney",
          img:
            "https://widgetwhats.com/app/uploads/2019/11/free-profile-photo-whatsapp-3-300x300.png"
        },
        {
          name: "Mark Douglae",
          img:
            "https://widgetwhats.com/app/uploads/2019/11/free-profile-photo-whatsapp-2.png"
        }*/
      ],
      pageName: 'Who are you visiting today?',
      data: null,
      userData: {},
      steps: [
        {
          title: 'Agreements',
          fields: [],
          footer: null
        }
      ],
      debounceTimeout: 0,
      showSubmitFeedback: false,
      qrCodeContent: sessionStorage.getItem("qrCodeContent")
    };
  },
  computed: {
    allowSkip() {
      try {
        return this.userData.visitor.contactType.rules.host !== 2;
      } catch (e) {
        return true;
      }
    },
    genCharArray() {
      return (charA, charZ) => {
        var a = [],
          i = charA.charCodeAt(0),
          j = charZ.charCodeAt(0);
        for (; i <= j; ++i) {
          a.push(String.fromCharCode(i));
        }
        return a;
      };
    }
  },
  created() {
    if (this.$root.location) this.data = this.$root.location;
  },
  mounted() {
    this.$parent.errorMsg = null;
    this.getLocalPost(this.getLocalPostCallback);
  },
  methods: {
    selectVisiting(visiting) {
      this.visiting = visiting;
    },
    closeModal() {
      this.visiting = null;
    },
    getLocalPostCallback(userData) {
      console.log('getLocalPostCallback', userData);
      this.userData = userData;
      if (!userData) {
        this.$parent.errorMsg = 'Please Enter Your Info';
        this.$router.push({
          name: 'signin'
        });
      } else {
        if (!this.data) this.$router.push('/' + this.$route.params.id);
        this.onAddressTyped();
        // this.getCheckInData(
        //   this.$route.params.id,
        //   this.getDataCallback,
        //   userData
        // );
      }
    },
    getDataCallback() {},
    skip() {
      this.postCheckInData({
        ...this.userData,
        visitor: {
          ...this.userData.visitor,
          hostedBy: undefined
        },
        questions: (this.$root.userData || {}).questions || {},
        ...(this.qrCodeContent && {qr: {data: this.qrCodeContent}})
      });
    },
    confirm() {
      this.state.isLoading = true;

      this.userData.visitor.hostedBy = this.visiting.id;
      const parsed = JSON.stringify(this.userData.visitor);
      localStorage.setItem('userVisitorData', parsed);

      this.postCheckInData({
        ...this.userData,
        questions: (this.$root.userData || {}).questions || {},
        ...(this.qrCodeContent && {qr: {data: this.qrCodeContent}})
      });
      this.closeModal();
    },
    debounce: function(func, wait) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(function() {
        func();
      }, wait);
    },
    goBack() {
      this.$router.push(`/${this.$route.params.id}/agree`);
    },

    onAddressTyped: function() {
      let me = this;
      const visitorContactTypeId = this.userData.visitor.contactType.id;
      me.debounce(function() {
        me.state.isLoading = true;
        var locationId = me.data.id; //location id
        axios
          .get('/locations/' + locationId + '/hosts', {
            params: {
              searchString: me.autoCompleteVisitor,
              visitorContactType: visitorContactTypeId,
              ...((me.autoCompleteVisitor || '').length === 1
                ? { searchType: 'startswith' }
                : {})
            }
          })
          .then(function(response) {
            console.log('response', response);

            if (response.data && response.data.items) {
              if (!me.autoCompleteVisitor) {
                const data = response.data;
                me.visitorResults = {
                  ...data,
                  items: data.items //.slice(0, 10)
                };
              } else {
                me.visitorResults = response.data;
              }
            } else {
              me.visitorResults = [];
            }

            me.state.isLoading = false;
          })
          .catch(function(error) {
            me.$parent.errorMsg = error;
            if (error.response.data && error.response.data.message) {
              me.$parent.errorMsg = error.response.data.message;
            }
            me.state.isLoading = false;
          });
      }, 250);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-input-placeholder {
  /* Edge */
  color: #ccc;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc;
}
::placeholder {
  color: #ccc;
}
input[type='search'] {
  border-radius: 15px;
  font-size: 1.1rem;
  height: 2rem;
  margin: 0.5rem 0;
  padding: 1.25rem;
}
.visitor-selected-hold {
  position: fixed;
  z-index: 999;
  display: flex;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.05);
  height: 100%;
  img {
    max-width: 180px;
    border-radius: 50%;
  }
  h4 {
    margin-bottom: 1rem;
  }
}
.visitor-selected {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 315px;
  max-height: 315px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.5);
  height: 100%;
  img {
    max-width: 180px;
    border-radius: 50%;
  }
  h4 {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.visiting-selected-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
}
.visitor-results {
  display: flex;
  margin: 0.25rem 0 1rem;
  width: 100%;
  justify-content: space-between;
  flex-flow: row wrap;
  li {
    &:hover {
      border: 1px solid #000;
    }
    img {
      max-width: 20%;
      border-radius: 50%;
      margin: 0 10px 0 0;
    }
    border-radius: 5px;
    border: 1px solid #ddd;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 49.2%;
    width: 100%;
    padding: 0.25rem;
    min-height: 70px;
    margin: 0.25rem 0;
    text-align: left;
    svg {
      margin-left: auto;
      fill: #ddd;
    }
  }
}
.visitor-results-details {
  h4,
  p {
    line-height: 1.2;
    margin: 1px 0 1px;
  }
  h4 {
    font-weight: bold;
  }
  p {
    font-size: 0.9rem;
  }
}

.visitor-selected {
  .visitor-results-details {
    font-size: 1.5rem;
    h4,
    p {
      line-height: 1.2;
      margin: 3px 0 3px;
    }
    p {
      font-size: 1rem;
    }
    margin: 10px 0;
  }
}
</style>
